// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1tCFw","legacyBtn":"MutateMid_legacyBtn__3lkgq"};